import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ArticleVO } from '@article/model/vo/article.vo';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ModalComponent } from '@shared/modal/modal.component';
import { LocaleUtils } from '@shared/util/locale-utils';

@Component({
  selector: 'app-select-from-multiple-found-articles',
  imports: [
    ModalComponent,
    TranslateModule,
  ],
  templateUrl: './select-from-multiple-found-articles.component.html',
  styleUrl: './select-from-multiple-found-articles.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectFromMultipleFoundArticlesComponent {
  @Output() public finish = new EventEmitter<ArticleVO>();

  public articles: ArticleVO[] = [];
  public displayNames: string[] = [];
  public images: string[] = [];

  constructor(private localeResourceManager: LocaleResourceManager) {
  }

  public ngOnInit(): void {
    this.displayNames = this.articles.map((article) =>
      LocaleUtils.getValueByLocaleChain(article.displayName, this.localeResourceManager.getLocaleChain()));
  }

  public selectArticle(article: ArticleVO): void {
    this.finish.emit(article);
  }
}
